<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <report-field :field-name="$t(reportParameters[0].label)">
        <treeselect
          v-model="reportParameters[0].value"
          :options="networkStartingPointOptions"
          :load-options="getNetworkStartingPointOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              technicalSiteLocalDisabled ||
              !userHasPermissionToList('technical_local')
          "
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>
      <report-field>
        <v-checkbox
          v-model="reportParameters[1].value"
          :label="$t(reportParameters[1].label)"
          :disabled="!hasPermissionToCreateExport"
          color="#4fa2b7"
          :ripple="false"
          :false-value="0"
          :true-value="1"
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "NetworkDiagramReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "NetworkStartingPoint",
          key: "technical_local",
          type: "text",
          value: undefined
        },
        {
          label: "IncludeSubscribers",
          key: "include_buildings",
          type: "checkbox",
          value: 0
        }
      ],

      historyFilter: "synoptic"
    };
  },

  computed: {
    buttonsDisabled() {
      return this.reportParameters[0].value === undefined;
    },
    technicalSiteLocalDisabled() {
      return this.selectedWorkspace === undefined;
    },
    dataToSend() {
      let includeSubscribers;
      if (this.reportParameters[1].value) includeSubscribers = "true";
      else includeSubscribers = "false";
      return {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.selectedWorkspace,
          object: {
            uuid: this.reportParameters[0].value,
            object_type: "technical_local",
            include_buildings: includeSubscribers
          }
        }
      };
    }
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);
      this.networkStartingPointOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/NetworkDiagram.vue